/* eslint-disable no-restricted-globals */
// import 'vite/modulepreload-polyfill';

import '../css/main.css';

import lazyLoadModule from './utils/loaders/moduleLoader.js';
import { init as initExternalLinks } from './modules/externalLinks.js';

initExternalLinks();

lazyLoadModule('alpineComponents', 100).then(() => {
  console.log('alpineComponents has been loaded');
});

// lazyLoadModule('lazy', 100).then(() => {
//   console.log('lazy has been loaded');
// });

// Lazy Images
const selector = 'img[loading="lazy"], iframe[loading="lazy"], source[data-srcset]';
const lazyImageEls = document.querySelectorAll(selector);
if (lazyImageEls.length > 0) {
  if ('loading' in HTMLImageElement.prototype) {
    lazyLoadModule('lazysizes', 100, { els: lazyImageEls, selector: selector }).then(() => {
      console.log('lazysizes has been loaded');
    });
  } else {
    // eslint-disable-next-line no-console
    // import('lazysizes')
    //   .then((LazySizes) => LazySizes.init())
    //   // eslint-disable-next-line no-console
    //   .catch((e) => console.error(`${e.name} : ${e.message}`));
  }
}

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  // HMR code
  import.meta.hot.accept();
}
